import { useEffect, useState } from "react";
import { PartyPopper, X } from "lucide-react";
import { useLang } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const THEMES = {
    default: "bg-brand-navy text-white",
    diwali: "bg-gradient-to-r from-[#7C2D12] via-[#B45309] to-[#7C2D12] text-white",
    camp: "bg-gradient-to-r from-brand-olive via-brand-lime to-brand-olive text-brand-navy",
};

export default function Banner() {
    const { isMr } = useLang();
    const [banner, setBanner] = useState(null);
    const [hidden, setHidden] = useState(false);

    useEffect(() => {
        fetch(`${API}/banner`)
            .then((r) => r.json())
            .then(setBanner)
            .catch(() => setBanner(null));
    }, []);

    if (!banner || !banner.enabled || hidden) return null;
    const text = isMr ? banner.text_mr : banner.text_en;
    if (!text) return null;

    return (
        <div className="relative z-10 pt-[72px]">
            <div
                data-testid="festival-banner"
                className={`relative overflow-hidden px-12 py-3.5 text-center text-sm font-semibold ${THEMES[banner.theme] || THEMES.default}`}
            >
                <PartyPopper className="pointer-events-none absolute left-5 top-1/2 h-4 w-4 -translate-y-1/2 opacity-60" />
                {text}
                {banner.link && (
                    <a
                        data-testid="banner-link"
                        href={banner.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ml-3 inline-flex items-center underline underline-offset-4 opacity-90 transition-opacity hover:opacity-100"
                    >
                        Know more
                    </a>
                )}
                <button
                    data-testid="banner-dismiss"
                    onClick={() => setHidden(true)}
                    aria-label="Dismiss banner"
                    className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-1.5 opacity-60 transition-opacity hover:opacity-100"
                >
                    <X className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
}
